import { CheckCircle2, CircleAlert, Lock, Link2 } from "lucide-react";

const LINKS = { logoff: "settings", otp: "settings", phi_email: "settings", retention: "settings", training: "training", audit: "audit" };

export function ComplianceChecklist({ data, onGo }) {
  if (!data) return <div className="text-sm text-slate-500">Loading…</div>;
  return (
    <div className="space-y-6">
      <ol className="divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white" data-testid="compliance-checklist">
        {data.items.map((it) => (
          <li key={it.key} data-testid={`checklist-item-${it.key}`} className="flex items-start gap-4 px-5 py-4">
            {it.ok ? <CheckCircle2 className="h-5 w-5 text-emerald-600 mt-0.5 flex-shrink-0" data-testid={`checklist-ok-${it.key}`} />
                   : <CircleAlert className="h-5 w-5 text-amber-500 mt-0.5 flex-shrink-0" data-testid={`checklist-todo-${it.key}`} />}
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2">
                <span className="text-sm font-semibold text-slate-900">{it.title}</span>
                {it.auto && <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-medium uppercase tracking-wider text-slate-500"><Lock className="h-3 w-3" /> built-in</span>}
              </div>
              <div className="text-sm text-slate-600 mt-0.5">{it.detail}</div>
            </div>
            {!it.ok && LINKS[it.key] && (
              <button onClick={() => onGo(LINKS[it.key])} data-testid={`checklist-fix-${it.key}`} className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline whitespace-nowrap"><Link2 className="h-3 w-3" /> Fix</button>
            )}
            {!it.ok && it.key === "baa" && (
              <a href="/hipaa#baa" target="_blank" rel="noreferrer" data-testid="checklist-fix-baa" className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:underline whitespace-nowrap"><Link2 className="h-3 w-3" /> Request BAA</a>
            )}
          </li>
        ))}
      </ol>
      <p className="text-xs text-slate-500 max-w-3xl">
        Logerd provides the technical safeguards required by the HIPAA Security Rule (45 CFR §164.312). Your organization remains responsible for administrative and physical
        safeguards — policies, risk analysis, device security and staff conduct. Items marked <b>built-in</b> are always on and cannot be disabled.
      </p>
    </div>
  );
}
